/**
 * Populates the state/province select based on the selected country.
 */
const populateStatesAndProvinces = () => {
    // Define an object that maps countries to their states or provinces
    const statesAndProvinces = {
        'United States': [
            'Alabama',
            'Alaska',
            'Arizona',
            'Arkansas',
            'California',
            'Colorado',
            'Connecticut',
            'Delaware',
            'Florida',
            'Georgia',
            'Hawaii',
            'Idaho',
            'Illinois',
            'Indiana',
            'Iowa',
            'Kansas',
            'Kentucky',
            'Louisiana',
            'Maine',
            'Maryland',
            'Massachusetts',
            'Michigan',
            'Minnesota',
            'Mississippi',
            'Missouri',
            'Montana',
            'Nebraska',
            'Nevada',
            'New Hampshire',
            'New Jersey',
            'New Mexico',
            'New York',
            'North Carolina',
            'North Dakota',
            'Ohio',
            'Oklahoma',
            'Oregon',
            'Pennsylvania',
            'Rhode Island',
            'South Carolina',
            'South Dakota',
            'Tennessee',
            'Texas',
            'Utah',
            'Vermont',
            'Virginia',
            'Washington',
            'West Virginia',
            'Wisconsin',
            'Wyoming',
        ],
        Canada: [
            'Ontario',
            'Quebec',
            'Nova Scotia',
            'New Brunswick',
            'Manitoba',
            'British Columbia',
            'Prince Edward Island',
            'Saskatchewan',
            'Alberta',
            'Newfoundland and Labrador',
        ],
    };

    const countrySelect = document.querySelector('.js-country-select');
    const stateProvinceSelect = document.querySelector('.js-state-select');

    // Check if the required elements exist
    if (!countrySelect && !stateProvinceSelect) return;

    const selectedCountry = countrySelect.value;

    if (selectedCountry) {
        // Clear the current options in the state/province select
        stateProvinceSelect.innerHTML = '';

        // Add the "Please select one..." option as the first option
        const defaultOption = document.createElement('option');
        defaultOption.value = '';
        defaultOption.text = 'Please select one...';
        stateProvinceSelect.appendChild(defaultOption);

        // Populate the state/province select with options based on the selected country
        for (const stateProvince of statesAndProvinces[selectedCountry]) {
            const option = document.createElement('option');
            option.value = stateProvince;
            option.text = stateProvince;
            stateProvinceSelect.appendChild(option);
        }
    }
};

/**
 * Initializes the country and state/province select elements and adds an event listener for changes.
 */
const initCountryStateSelect = () => {
    const countrySelect = document.querySelector('.js-country-select');
    countrySelect &&
        countrySelect.addEventListener('change', populateStatesAndProvinces);
};

export default initCountryStateSelect;
